import { HttpErrorResponse } from "@angular/common/http";
import { Component, Inject } from "@angular/core";
import { MatDialog, MatPaginator } from "@angular/material";
import { Router } from "@angular/router";
import pdfMake from 'pdfmake/build/pdfmake';
import { GenericModalComponent } from "./generic-modal/generic-modal.component";
import { ModalAjudaAtivacaoKriptonitaComponent } from "./modal-ajuda-ativacao-kriptonita/modal-ajuda-ativacao-kriptonita.component";
import { ModalCnsBasicoComponent } from "./modal-cns-basico/modal-cns-basico.component";
import { MessageService } from "./services/message.service";
import InscricaoUtils from "./utils/inscricao-utils";
import Utils from "./utils/utils";

@Component({
    selector: 'CnsController',
    template: '<div></div>'
})
export class CnsController {

    constructor(
        private routerCns: Router,
        private dialogCns: MatDialog,
        private messageServiceCns: MessageService
    ) { }

    formatarInscricao(inscricao: string) {
        const tpInscricao: string = (inscricao + '').substr(0, 1);
        return InscricaoUtils.mascararInscricao(tpInscricao, +inscricao);
    }

    formatarData(timeStamp: any): string {
        if (timeStamp === null || timeStamp.substring(0, 4) == '0001') {
            return "";
        } else {
            const data = new Date(timeStamp);
            return data.toLocaleDateString('pt-BR');
        }
    }

    openDialog(mensagem: string, action: string, titulo: string, labelconfirmar: string, labelcancelar: string, help: boolean): string {
        this.dialogCns.open(GenericModalComponent, { data: { mensagem, action, titulo, labelconfirmar, labelcancelar, help } });
        return mensagem;
    }

    openDialogHelp(titulo: string) {
        this.dialogCns.open(ModalAjudaAtivacaoKriptonitaComponent, { data: { titulo } });
    }

    mostraAcessoNegado(titulo: string, descErro: string) {
        const msg: string = titulo === '' ? descErro : titulo + ' : ' + descErro;
        this.messageServiceCns.changeErrorMessage(0, msg);
        this.routerCns.navigate(['/acesso-negado']);
    }

    mostraErroInterno(titulo: string, descErro: string) {
        this.messageServiceCns.changeErrorMessage(0, titulo + ' : ' + descErro);
        this.routerCns.navigate(['/erro-interno']);
    }

    trataErroResponse(respErro: HttpErrorResponse, titulo: string) {

        if (!titulo || '' === titulo) {
            titulo = 'Erro interno:';
        }

        const descErro = respErro.error.errors ? JSON.stringify(respErro.error.errors[0].mensagem) : respErro.message;
        console.error(descErro);

        const status = respErro.status;

        switch (status) {
            case 0:
                let srvIndsp = 'Serviço indisponível';
                if ('TOKEN' === titulo) {
                    titulo = ''; //'Erro ao obter Token';
                    srvIndsp = 'Sistema indisponível no momento, favor tentar mais tarde. (A001)';
                }
                if ('NODE' === titulo) {
                    titulo = ''; //'Erro ao validar Certificado digital.';
                    srvIndsp = 'Sistema indisponível no momento, favor tentar mais tarde. (N001)';
                }
                this.mostraAcessoNegado(titulo, srvIndsp);
                break;

            case 401:
                this.mostraAcessoNegado(titulo, descErro);
                break;

            default:
                this.mostraErroInterno(titulo, descErro);
                break;
        }

    }

    private trataErroTypeError(error: TypeError, titulo: string) {
        console.error(error);
        this.mostraErroInterno('Erro interno', error.message);
    }

    trataErro(error: any, titulo: string) {

        const errorType = error.constructor.name;

        switch (errorType) {

            case 'HttpErrorResponse':
                this.trataErroResponse(<HttpErrorResponse>error, titulo);
                break;

            case 'TypeError':
                this.trataErroTypeError(<TypeError>error, titulo);
                break;

            case 'A':
                //para os ambientes de DES a PRD
                this.trataErroResponse(<HttpErrorResponse>error, titulo);
                break;

            default:
                this.mostraAcessoNegado(titulo, error);
                break;
        }

    }

    popupModalCnsBasico(params: any) {
        setTimeout(() => {
            this.dialogCns.open(ModalCnsBasicoComponent, params);
        }, 150);
    }

    downloadPDF(docDefinition, nomeArquivo: string) {
        pdfMake.createPdf(docDefinition).download(nomeArquivo);
    }

    customPaginator(paginator: MatPaginator) {
        paginator._intl.itemsPerPageLabel = 'Ítens por página:';
        paginator._intl.nextPageLabel = 'Próxima página';
        paginator._intl.firstPageLabel = 'Primeira página';
        paginator._intl.lastPageLabel = 'Última página';
        paginator._intl.previousPageLabel = 'Página anterior';
        paginator._intl.getRangeLabel =
            (page: number, pageSize: number, length: number) => {
                return ((page * pageSize) + 1) + ' - ' + (length > (page + 1) * pageSize ? ((page + 1) * pageSize) : length) + ' de ' + length;
            };
    }

    protected promptDownload(url, nomeArquivoComExtensao) {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.href = url;
        a.download = nomeArquivoComExtensao;
        a.click();
        setTimeout(function () {
            window.URL.revokeObjectURL(url);
        }, 100);
    }

    protected gerarURLDownload(arquivo, contentType, nomeArquivoComExtensao, sliceSize?): string {
        const blob = Utils.b64toBlob(arquivo, contentType, sliceSize);
        const url = URL.createObjectURL(blob);
        return url;
    }
}